import React from 'react';
import { useTranslation } from 'react-i18next';
import { CTA_LIST } from '../../constants/CtaList';
import { CTAButton, Text, EditLocationCTA, TextCTA } from './CTA.style';
import EditIcon from '../../assets/icons/EditIcon';
import GpsIcon from '../../assets/icons/GpsIcon';
import ArrowIcon from '../../assets/icons/ArrowIcon';
import Spinner from '../Spinner';

interface CTATypes {
  buttonType: string;
  onModalOpen?: () => void;
  onChange?: () => void;
  onSetLoadingTrue?: () => void;
  failToGetLocation?: () => void;
  loading?: boolean;
  onGetLocation?: (position: GeolocationPosition) => void;
  buttonText?: string;
  noGap?: boolean;
  arrowAfter?: boolean;
}

const CTA: React.FC<CTATypes> = ({
  buttonType,
  onModalOpen,
  onChange,
  onGetLocation,
  failToGetLocation,
  onSetLoadingTrue,
  loading,
  buttonText,
  arrowAfter,
  noGap,
}) => {
  const { t } = useTranslation();

  const handleClick = () => {
    onSetLoadingTrue?.();
    if (navigator.geolocation && buttonType === CTA_LIST.GPS_CTA && onGetLocation) {
      navigator.geolocation.getCurrentPosition(onGetLocation, failToGetLocation);
    } else {
      console.log('Geolocation is not supported by this browser.');
    }
  };

  const handleEditLocationCta = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.currentTarget.blur();
    if (onChange) {
      onChange();
    }
  };

  const openModal = (
    <CTAButton buttonClass="openModal" onClick={onModalOpen}>
      <Text>open modal</Text>
    </CTAButton>
  );

  const editLocation = (
    <EditLocationCTA buttonClass="editLocation" onClick={handleEditLocationCta}>
      <Text>{buttonText}</Text>
      <EditIcon />
    </EditLocationCTA>
  );

  const gpsCta = (
    <TextCTA buttonClass="gpsCta" onClick={handleClick}>
      {loading ? <Spinner size={24} /> : <GpsIcon />}
      <Text>{t('dealerLocationSearch.searchBar.geoLocationSearch')}</Text>
    </TextCTA>
  );

  const backToRadius = (
    <TextCTA className={noGap ? 'noGap' : ''} buttonClass="back" onClick={onChange}>
      {!arrowAfter && <ArrowIcon arrowType="left" />}
      <Text>{t('dealerLocationSearch.dealersList.back')}</Text>
      {arrowAfter && <ArrowIcon arrowType="down" />}
    </TextCTA>
  );

  if (buttonType === CTA_LIST.OPEN_MODAL) return openModal;
  if (buttonType === CTA_LIST.EDIT_LOCATION) return editLocation;
  if (buttonType === CTA_LIST.GPS_CTA) return gpsCta;
  if (buttonType === CTA_LIST.BACK_TO_RADIUS) return backToRadius;
  return null;
};

export default CTA;
